/**
 * Labstep
 *
 * @module core/ChemDraw
 * @desc ChemDraw component
 */

import { Loadable } from 'labstep-web/core/Loadable';
import React from 'react';
import type { IChemDrawContainerProps } from './types';

export const ChemDrawComponent = React.lazy(() =>
  import('./component').then((module) => ({
    default: module.ChemDrawContainer,
  })),
);

export const ChemDraw: React.FC<IChemDrawContainerProps> = (
  props,
) => {
  return (
    <Loadable>
      <ChemDrawComponent {...props} />
    </Loadable>
  );
};
